import { render, staticRenderFns } from "./OtherWorkingAdd.vue?vue&type=template&id=3870a3a0&"
import script from "./OtherWorkingAdd.vue?vue&type=script&lang=js&"
export * from "./OtherWorkingAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports